/**
 * Copies a user-picked file's bytes into memory before it is sent.
 *
 * A `File` from the picker or a drop is only a handle: the browser reads the bytes lazily when
 * `fetch` streams the request body. For files that are not ordinary files on disk (a photo dragged
 * or picked straight from the macOS Photos library, an un-downloaded iCloud file, a temporary
 * screenshot) that late read is refused, and the whole request fails with the opaque
 * `net::ERR_ACCESS_DENIED` / "Failed to fetch" — the server never sees it. Reading the bytes
 * up front, while the user's selection is still fresh, either succeeds (and the upload then comes
 * from memory) or fails here with a message that tells the user what to do.
 */
export const UNREADABLE_FILE_MESSAGE = "We couldn't read this file. If it came from the Photos app, export it (File > Export) to your Desktop first, then upload it from there.";
export async function readFileIntoMemory(file) {
    try {
        const bytes = await file.arrayBuffer();
        return new File([bytes], file.name, { type: file.type, lastModified: file.lastModified });
    }
    catch {
        throw new Error(UNREADABLE_FILE_MESSAGE);
    }
}
//# sourceMappingURL=read-file-into-memory.js.map